const RedirectsMap = {
  ServerRootUrl: import.meta.env.VITE_LEGACY_REACT_ADMIN_DASHBOARD_URL,
  MobileConsentSolutions: "universal_consent_solutions",
  ComplianceDashboard: "compliance_dashboard",
  CookiePolicy: "policy",
  SubscriptionPlan: "subscription?step=plan",
};

export default RedirectsMap;
